import PropTypes from "prop-types";
import { Box, List, ListItemText } from "@mui/material";
import { StyledNavItem, StyledNavItemIcon } from "./NavSection.styles";
import navConfig from "./config";
import Iconify from "../iconify/Iconify";
import { useNavigate } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";

const NavItem = ({ item }) => {
    const navigate = useNavigate();
    const permissions = usePermissions();
    const { title, path, icon, info } = item;

    const hasPermission = (nav_permission) => {
        return nav_permission.some((np) => permissions.has(np));
    }

    return (
        <StyledNavItem
            // to={path}

            sx={{
                "&.active": {
                    color: "text.primary",
                    bgcolor: "action.selected",
                    fontWeight: "fontWeightBold",
                },
            }}
            onClick={() => navigate(path)}
        >
            <StyledNavItemIcon>
                <Iconify icon={icon} />
            </StyledNavItemIcon>
            <ListItemText disableTypography primary={title} />
            {info && info}
        </StyledNavItem>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
};

const NavSection = () => {
    const permissions = usePermissions();

    return (
        <Box>
            <List disablePadding sx={{ p: 1 }}>
                {navConfig.filter((nav) => nav.permissions.some((per) => permissions.has(per))).map((item) => (
                    <NavItem key={item.title} item={item} />
                ))}
            </List>
        </Box>
    );
};

NavSection.propTypes = {
    data: PropTypes.array,
};

export default NavSection;
